module.exports = __webpack_public_path__ + "static/media/QuizzApp-JavaScript.64293068.png";